export default {
    "RUSSIAN": "ru"
}
